import { BADGE_TYPE } from 'consts/enum';
import './badge.scss';

export const BadgeTemplate = (model) => {
	const { style = '', id = '', type, count } = model;

	let className = '';

	if (type === BADGE_TYPE.MINI) {
		className = 'engt-badge-mini';
	} else if (type === BADGE_TYPE.SMALL) {
		className = 'engt-badge-small';
	} else if (type === BADGE_TYPE.MEDIUM) {
		className = 'engt-badge-medium';
	} else if (type === BADGE_TYPE.LARGE) {
		className = 'engt-badge-large';
	}

	/* html */
	const html = `
		<div class="engt-badge ${className}" id="${id}" style="${style}">${count}</div>
    `;

	return html;
};
